export default __webpack_public_path__ + "static/media/ic_tracking.0b7c034d.svg";